import store from './store'
import { createWebHistory, createRouter } from 'vue-router';

const LoginPage = () => import(/* webpackChunkName: "auth" */ './pages/Login.vue');
const PrivacyPolicy = () => import(/* webpackChunkName: "auth" */ './pages/PrivacyPolicy.vue');
const ChangePasswordPage = () => import(/* webpackChunkName: "auth" */ './pages/ChangePassword.vue');
const ForgetPasswordPage = () => import(/* webpackChunkName: "auth" */ './pages/ForgetPassword.vue');
const ResetPasswordPage = () => import(/* webpackChunkName: "auth" */ './pages/ResetPassword.vue');
const SetPasswordPage = () => import(/* webpackChunkName: "auth" */ './pages/SetPassword.vue');
const SuccessPage = () => import(/* webpackChunkName: "auth" */ './pages/Success.vue');
const AlreadySuccessPage = () => import(/* webpackChunkName: "auth" */ './pages/Already-Success.vue');

const DashboardPage = () => import(/* webpackChunkName: "dashboard" */ './pages/Dashboard.vue');
const CalendarPage = () => import(/* webpackChunkName: "dashboard" */ './pages/Calendar.vue');

const UserPage = () => import(/* webpackChunkName: "users" */ './pages/User.vue');
const AddUsersPage = () => import(/* webpackChunkName: "users" */ './crud/AddUsers.vue');
const EditUsersPage = () => import(/* webpackChunkName: "users" */ './crud/EditUsers.vue');
const ViewUsersPage = () => import(/* webpackChunkName: "users" */ './crud/ViewUsers.vue');

const ClientsPage = () => import(/* webpackChunkName: "clients" */ './pages/Clients.vue');
const AddClientsPage = () => import(/* webpackChunkName: "clients" */ './crud/AddClients.vue');
const EditClientsPage = () => import(/* webpackChunkName: "clients" */ './crud/EditClients.vue');
const ViewClientsPage = () => import(/* webpackChunkName: "clients" */ './crud/ViewClients.vue');

const EventsPage = () => import(/* webpackChunkName: "events" */ './pages/Events.vue');
const AddEventsPage = () => import(/* webpackChunkName: "events" */ './crud/AddEvents.vue');
const EditEventsPage = () => import(/* webpackChunkName: "events" */ './crud/EditEvents.vue');
const ViewEventsPage = () => import(/* webpackChunkName: "events" */ './crud/ViewEvents.vue');

const BillingsPage = () => import(/* webpackChunkName: "billings" */ './pages/Billings.vue');
const AddBillingsPage = () => import(/* webpackChunkName: "billings" */ './crud/AddBillings.vue');
const EditBillingsPage = () => import(/* webpackChunkName: "billings" */ './crud/EditBillings.vue');
const ViewBillingsPage = () => import(/* webpackChunkName: "billings" */ './crud/ViewBillings.vue');

const ClientsReportPage = () => import(/* webpackChunkName: "reports" */ './pages/ClientsReport.vue');
const EventsReportPage = () => import(/* webpackChunkName: "reports" */ './pages/EventsReport.vue');
const SalesReportPage = () => import(/* webpackChunkName: "reports" */ './pages/SalesReport.vue');
const TransactionsReportPage = () => import(/* webpackChunkName: "reports" */ './pages/TransactionsReport.vue');
const LoginHistoryPage = () => import(/* webpackChunkName: "reports" */ './pages/LoginHistory.vue');

// Audit pages
const AuditLogsPage = () => import(/* webpackChunkName: "audit" */ './admin/pages/AuditLogs.vue');
const AuditAlertsPage = () => import(/* webpackChunkName: "audit" */ './admin/pages/AuditAlerts.vue');
const AuditCompliancePage = () => import(/* webpackChunkName: "audit" */ './admin/pages/AuditCompliance.vue');

const EventsReportPDFPage = () => import(/* webpackChunkName: "reports-pdf" */ './pages/EventsReportPDF.vue');
const SalesReportPDFPage = () => import(/* webpackChunkName: "reports-pdf" */ './pages/SalesReportPDF.vue');
const TransactionsReportPDFPage = () => import(/* webpackChunkName: "reports-pdf" */ './pages/TransactionsReportPDF.vue');
const ClientsReportPDFPage = () => import(/* webpackChunkName: "reports-pdf" */ './pages/ClientsReportPDF.vue');

const PageNotFoundPage = () => import(/* webpackChunkName: "errors" */ './pages/PageNotFound.vue');
const RedirectPayment = () => import(/* webpackChunkName: "payment" */ './pages/RedirectPayment.vue');

const routes = [
  { path: '/', name: 'Login', component: LoginPage, meta: {checkLogin: true} },
  { path: '/privacypolicy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/payment/:id', name: 'RedirectPayment', component: RedirectPayment },
  { path: '/changepassword', name: 'ChangePassword', component: ChangePasswordPage, meta: {requireLogin: true} },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPasswordPage, meta: { requireLogin: false } },
  { path: '/set-password', name: 'SetPassword', component: SetPasswordPage, meta: { requireLogin: false } },
  { path: '/reset_password', redirect: to => {
    const query = { ...to.query };
    return { path: '/reset-password', query };
  }},
  { path: '/onboarding/setup-password', redirect: to => {
    const query = { ...to.query };
    return { path: '/set-password', query };
  }},
  { path: '/forgetpassword', name: 'ForgetPassword', component: ForgetPasswordPage },
  { path: '/email/verify/success', name: 'Success', component: SuccessPage },
  { path: '/email/verify/already-success', name: 'Already-Success', component: AlreadySuccessPage },
  { path: '/dashboard', name: 'Dashboard', component: DashboardPage, meta: {requireLogin: true} },
  { path: '/users', name: 'User', component: UserPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/addusers', name: 'AddUsers', component: AddUsersPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/editusers/:id', name: 'EditUsers', component: EditUsersPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/viewusers/:id', name: 'ViewUsers', component: ViewUsersPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/clients', name: 'Clients', component: ClientsPage, meta: {requireLogin: true} },
  { path: '/addclients', name: 'AddClients', component: AddClientsPage, meta: {requireLogin: true} },
  { path: '/editclients/:id', name: 'EditClients', component: EditClientsPage, meta: {requireLogin: true} },
  { path: '/viewclients/:id', name: 'ViewClients', component: ViewClientsPage, meta: {requireLogin: true} },
  { path: '/addevents', name: 'AddEvents', component: AddEventsPage, meta: {requireLogin: true} },
  { path: '/editevents/:id', name: 'EditEvents', component: EditEventsPage, meta: {requireLogin: true} },
  { path: '/viewevents/:id', name: 'ViewEvents', component: ViewEventsPage, meta: {requireLogin: true} },
  { path: '/events', name: 'Events', component: EventsPage, meta: {requireLogin: true} },
  { path: '/billings', name: 'Billings', component: BillingsPage, meta: {requireLogin: true} },
  { path: '/addbillings', name: 'AddBillings', component: AddBillingsPage, meta: {requireLogin: true} },
  { path: '/editbillings/:id', name: 'EditBillings', component: EditBillingsPage, meta: {requireLogin: true} },
  { path: '/viewbillings/:id', name: 'ViewBillings', component: ViewBillingsPage, meta: {requireLogin: true} },
  { path: '/clientsreport', name: 'ClientsReport', component: ClientsReportPage, meta: {requireLogin: true} },
  { path: '/eventsreport', name: 'EventsReport', component: EventsReportPage, meta: {requireLogin: true} },
  { path: '/salesreport', name: 'SalesReport', component: SalesReportPage, meta: {requireLogin: true} },
  { path: '/transactionsreport', name: 'TransactionsReport', component: TransactionsReportPage, meta: {requireLogin: true} },
  { path: '/eventsreportpdf', name: 'EventsReportPDF', component: EventsReportPDFPage, meta: {requireLogin: true} },
  { path: '/salesreportpdf', name: 'SalesReportPDF', component: SalesReportPDFPage, meta: {requireLogin: true} },
  { path: '/login-history', name: 'LoginHistory', component: LoginHistoryPage, meta: {requireLogin: true} },
  { path: '/transactionsreportpdf', name: 'TransactionsReportPDF', component: TransactionsReportPDFPage, meta: {requireLogin: true} },
  { path: '/clientsreportpdf', name: 'ClientsReportPDF', component: ClientsReportPDFPage, meta: {requireLogin: true} },
  { path: '/:pathMatch(.*)*', name: 'PageNotFound', component: PageNotFoundPage, meta: {requireLogin: true} },
  { path: '/calendar', name: 'Calendar', component: CalendarPage, meta: {requireLogin: true} },

  // Audit routes (admin only)
  { path: '/audit-logs', name: 'AuditLogs', component: AuditLogsPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/audit-alerts', name: 'AuditAlerts', component: AuditAlertsPage, meta: {requireLogin: true, requireAdmin: true} },
  { path: '/audit-compliance', name: 'AuditCompliance', component: AuditCompliancePage, meta: {requireLogin: true, requireAdmin: true} },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
    next('/')
  }
  else if (to.matched.some(record => record.meta.checkLogin) && store.state.isAuthenticated) {
    next('/dashboard')
  }
  else if (to.matched.some(record => record.meta.requireAdmin) && localStorage.getItem('role') != 1) {
    next('/dashboard')
  }
  else {
    next()
  }
})

export default router;
